import React, { useState, useEffect } from "react";
import { Modal, Button, SearchDropdown } from '@prosolve/common-components-ui'
import useDataTrainers from "../../../../dataHooks/useDataTrainers";

export default ({
  eventId,
  onClose,
  onSuccess,
  isLead
}) => {

  const {
    fetchAllTrainers,
    addNewTrainer
  } = useDataTrainers()

  const [trainers, setTrainers] = useState([])

  const [selectedTrainer, setSelectedTrainer] = useState()

  const [filterOptionsVal, setFilterOptionsVal] = useState()

  const [isBusy, setIsBusy] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const getAllTrainers = async () => {
    setIsLoading(true)
    try {
      const allTrainers = await fetchAllTrainers();
      setTrainers(allTrainers)
    } catch (e) {
      setTrainers([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    getAllTrainers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filteredTrainers = trainers
    .reduce(function(filtered, trainer) {
      const { id = '', name = '' } = trainer;

      let passesFilter;
      if (filterOptionsVal) {
        if (name.toLowerCase().includes(filterOptionsVal.toLowerCase())) {
          passesFilter = true;
        } else {
          passesFilter = false;
        }
      } else {
        passesFilter = false;
      }

      if (passesFilter) {
        filtered.push({ value : id, text: name });
      }

      return filtered;
    }, [])
    .sort(({ text: textA }, {text: textB }) => {
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    })

  const onClickSubmit = async () => {
    if (!isBusy && selectedTrainer) {
      setIsBusy(true)

      try {
        await addNewTrainer({ trainerId: selectedTrainer, eventId, isLead })
        setIsBusy(false)
        onSuccess()
      } catch (e) {
        console.log(e)
        setIsBusy(false)
        onClose()
      }
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Add Trainer'}
      </Button>
    </div>
  )

  return (
    <Modal title='Add Trainer' isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div style={{
          display: 'flex'
        }}>
          <div style={{ color: '#565656', fontSize: '14px' }}>
            {'Search for a trainer to add to this event'}
          </div>
        </div>
        <div style={{
          // display: 'flex',
          // height: '230px',
          width: '100%'
        }}>
          <SearchDropdown
            options={filteredTrainers}
            onChange={(val) => setSelectedTrainer(val)}
            onSearch={(val) => setFilterOptionsVal(val)}
            isLoading={isLoading}
            suppressInputLoading={true}
            style={{ flex: 1 }}
            width='100%'
            maxHeight='200px'
          />
          {/* <FormField
            style={{ flex: 1 }}
            fieldId='email'
            type='text'
            label='Email'
            placeholder='e.g. jsmith@gmail.com'
            formData={formData}
          /> */}
        </div>
      </div>
    </Modal>
  )
}